import {TitleLink} from 'common/types'
import {atom} from 'jotai'

// Loading state

// Error & success messages
export const errorAtom = atom<Error | undefined>(undefined)
export const successMessageAtom = atom<string | undefined>(undefined)

// Form state
export const isFormDirtyAtom = atom<boolean>(false)
export const isWarningModalShownAtom = atom<boolean>(false)

// Pending navigation callback
export const pendingCallbackAtom = atom<(() => void) | null>(null)

export const pageLinksAtom = atom<TitleLink[]>([])

// handle navigation
export const handleNavigateAtom = atom(null, (get, set, callback: () => void) => {
  const isFormDirty = get(isFormDirtyAtom)

  if (isFormDirty) {
    set(isWarningModalShownAtom, true)
    set(pendingCallbackAtom, () => callback)
    return
  }

  callback()
})

// discard changes
export const handleDiscardAtom = atom(null, (get, set) => {
  const callback = get(pendingCallbackAtom)

  set(isFormDirtyAtom, false)
  set(isWarningModalShownAtom, false)

  if (callback) {
    callback()
  }

  set(pendingCallbackAtom, null)
})
